/* global JSX */
import React from 'react';
import { createStyles, keyframes } from '../../utils/css';
import { ExtractProps } from '../../utils/types';
import Icon from './Icon';

const spinnerFrames = keyframes({
  '0%': {
    transform: 'rotate(0deg)',
  },
  '100%': {
    transform: 'rotate(360deg)',
  },
});

const Styles = createStyles({
  spinner: {
    animationName: spinnerFrames,
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'steps(12, start)',
    transformOrigin: '50% 50%',
  },
});

interface IProps extends Omit<ExtractProps<typeof Icon>, 'children' | 'viewBox'> {
  color?: JSX.IntrinsicElements['rect']['color'];
}

function Spinner({ color = '#FFFFFF', ...props }: IProps) {
  const rectProps = {
    x: '46.5',
    y: '40',
    width: '7',
    height: '20',
    rx: '5',
    ry: '5',
    fill: color,
  };

  return (
    <Styles>{(css) =>
      <Icon {...props} viewBox="0 0 100 100">
        <rect x="0" y="0" width="100" height="100" fill="none" />
        <g className={css('spinner')}>
          <rect {...rectProps} opacity={1 / 12} transform="rotate(0 50 50) translate(0 -30)" />

          <rect {...rectProps} opacity={2 / 12} transform="rotate(30 50 50) translate(0 -30)" />
          <rect {...rectProps} opacity={3 / 12} transform="rotate(60 50 50) translate(0 -30)" />
          <rect {...rectProps} opacity={4 / 12} transform="rotate(90 50 50) translate(0 -30)" />
          <rect {...rectProps} opacity={5 / 12} transform="rotate(120 50 50) translate(0 -30)" />
          <rect {...rectProps} opacity={6 / 12} transform="rotate(150 50 50) translate(0 -30)" />
          <rect {...rectProps} opacity={7 / 12} transform="rotate(180 50 50) translate(0 -30)" />
          <rect {...rectProps} opacity={8 / 12} transform="rotate(210 50 50) translate(0 -30)" />
          <rect {...rectProps} opacity={9 / 12} transform="rotate(240 50 50) translate(0 -30)" />
          <rect {...rectProps} opacity={10 / 12} transform="rotate(270 50 50) translate(0 -30)" />
          <rect {...rectProps} opacity={11 / 12} transform="rotate(300 50 50) translate(0 -30)" />
          <rect {...rectProps} transform="rotate(330 50 50) translate(0 -30)" />
        </g>
      </Icon>
    }</Styles>
  );
}

export default Spinner;
